import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M39.2174 9.76957C40.2609 10.7167 40.2609 12.3743 39.2174 13.3215L18.6689 33.5277C17.7057 34.5538 16.0201 34.5538 15.0569 33.5277L4.78261 23.4246C3.73913 22.4774 3.73913 20.8199 4.78261 19.8727C5.74582 18.8466 7.43144 18.8466 8.39465 19.8727L16.903 28.1604L35.6054 9.76957C36.5686 8.74348 38.2542 8.74348 39.2174 9.76957Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
